import { render } from "./ProductModelElementsChangeAddTab.vue?vue&type=template&id=09306b30"
import script from "./ProductModelElementsChangeAddTab.vue?vue&type=script&lang=js"
export * from "./ProductModelElementsChangeAddTab.vue?vue&type=script&lang=js"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__